/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import RemoveUsersForm from './RemoveUsersForm/RemoveUsersForm';
import RemoveUsersSuccess from './RemoveUsersSuccess/RemoveUsersSuccess';
import RemoveUsersError from './RemoveUsersError/RemoveUsersError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  companyId: string,
  countryId: string,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveUsers extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, location }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'removeUsers',
        label: t('general:actions.remove_location_from'),
        fields: [
          {
            name: 'users',
            label: t('general:user_plural'),
            rules: 'required|array',
            value: [],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { users }: Object = data.values().removeUsers;

        actionDrawerStore.removeLocationFromUsers(location.id, {
          user_ids: users.join(),
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'removeLocationFromUsers',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location, companyId, countryId }: TypeProps = this.props;

    const title: string = t('general:actions.remove_users_from_location');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RemoveUsersError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RemoveUsersSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RemoveUsersForm
          location={location}
          companyId={companyId}
          countryId={countryId}
          form={this.createForm()}
        />
      </div>
    );
  }
}
